export const genderArr = ['female', 'male']
